export default __webpack_public_path__ + "static/media/etf logo 3.a4f7809d.svg";